export enum SellTransactionActionTypes {
  DISTRIBUTION_BENEFICIARY_ADDRESS = 'DISTRIBUTION_BENEFICIARY_ADDRESS',
  DISTRIBUTION_BENEFICIARY_ADDRESS_FULFILLED = 'DISTRIBUTION_BENEFICIARY_ADDRESS_FULFILLED',
  DESELECT_SELL_FUND = '@@sell/DESELECT_FUND',
  SELECT_SELL_FUND = '@@sell/SELECT_FUND',
  UPDATE_SELL_FUND = '@@sell/UPDATE_FUND',

  UPDATE_SELL_UNIQUE_IDS = '@@autoSell/UPDATE_SELL_UNIQUE_IDS',
  UPDATE_DAY_SELECTION = '@@autoSell/UPDATE_DAY_SELECTION',
  UPDATE_MONTH_SELECTION = '@@autoSell/UPDATE_MONTH_SELECTION',
  UPDATE_FEDERAL_WITHHOLDING = '@@sell/UPDATE_FEDERAL_WITHHOLDING',

  RESET_TRANSACTION = 'RESET_TRANSACTION',

  UPDATE_RMD_SHOULD_VALIDATE = 'UPDATE_RMD_SHOULD_VALIDATE',
}
